import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import Moment from "moment";
import { Component, default as React } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';


const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class CityscopeList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            cityscopes: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        console.log("In CityscopeList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const cityscopes = await this.getCityscopes();
            this.setState({ cityscopes });
        } catch (e) {
            alert(e);
        }
        document.title = "Cityscope lookup";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ cityscopes: [] });        
    }


    
    async getCityscopes() {
        console.log("Inside getCityscopes() ");
        
        return API.get("colin", "/cityscopes");
      
    }

    

    addRecord = async event => {
        let cityscopes = [...this.state.cityscopes];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        cityscopes.push({
            appendix:0,
            include_globe: false,
            allow_editing: false,
            led_occs: false,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({cityscopes});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/cityscopes/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/cityscopes/${record["cityscope"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

       
        //Check street name not blank
        if (record.cityscope === "") {
            return [false,"Cityscope cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let cityscopes = [...this.state.cityscopes];
        if (cellInfo.column.id === "cityscope" && !cityscopes[cellInfo.index].new_record)
        {
            alert("You cannot modify an existing cityscope code");
            return
        }
        cityscopes[cellInfo.index][cellInfo.column.id] = event.target.value;
        cityscopes[cellInfo.index].modified = true;
        this.setState({cityscopes});
    };
    handleNumberChange = (cellInfo, event) => {
        let cityscopes = [...this.state.cityscopes];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        cityscopes[cellInfo.index][cellInfo.column.id] = Number(val);
        cityscopes[cellInfo.index].modified = true;
        this.setState({cityscopes});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let cityscopes = [...this.state.cityscopes];
        cityscopes[cellInfo.index][cellInfo.column.id] = event.target.checked;
        cityscopes[cellInfo.index].modified = true;
        this.setState({cityscopes});
    };

    handleDateChange = (cellInfo, event) => {
        let cityscopes = [...this.state.cityscopes];
        cityscopes[cellInfo.index][cellInfo.column.id] = new Date(event);
        cityscopes[cellInfo.index].modified = true;
        this.setState({cityscopes});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let cityscopes = [...this.state.cityscopes];
        for (var i=0; i<cityscopes.length; i++){
            const validation = this.validateRecord(cityscopes[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (cityscopes[i].hasOwnProperty("modified")) {
                    if (cityscopes[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (cityscopes[i].hasOwnProperty("new_record")) {
                                if (cityscopes[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(cityscopes[i]);
                            if (result.result) {
                                cityscopes[i].modified = false;
                                if (cityscopes[i].hasOwnProperty("new_record")) {
                                    if (cityscopes[i].new_record === true) {

                                        cityscopes[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    cityscopes[i].new_record = false;
                                    
                                }
                                else{
                                    const cityscopes = await this.getCityscopes();
                                    this.setState({ cityscopes });
                                }
                                
                                                               
                            }
                            else {
                                cityscopes[i].issue_date = null;
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (cityscopes[0].hasOwnProperty("sort_order")) {
            cityscopes.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({cityscopes});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.cityscopes[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [
            {
                id: 'cityscope',
                Header: '',
                accessor: 'cityscope',
                maxWidth: 120,
                Cell: e=> <LinkContainer to={`/schedules/${e.original.cityscope}`} ><Button  type="button" size="sm" variant="primary">View Schedule</Button></LinkContainer>
            },
            {
                id: 'cityscope',
                Header: 'Cityscope',
                maxWidth: 150,
                accessor: 'cityscope' ,
                Cell: this.renderEditable
                

        }
        , {
                id: 'cityscope_name',
                Header: 'Name',            
                accessor: 'cityscope_name',
                maxWidth: 250,
                Cell: this.renderEditable
                

            }, {
                id: 'appendix',
                Header: 'Appendix',            
                accessor: 'appendix',
                maxWidth: 150,
                Cell: this.renderEditable

            }
            , {
                id: 'issue_date',
                Header: 'Issue Date',            
                accessor: d => {
                            if (d.issue_date) {
                                return Moment(d.issue_date)
                                    .local()
                                    .format("DD-MM-YYYY")
                            }
                            else { return null }
                        },
                maxWidth: 150

            }
            // , {
            //     id: 'next_issue_date',
            //     Header: 'Next Issue Date',
            //     maxWidth: 200,
            //     accessor: d => {
            //         if (d.next_issue_date) {
            //             return Moment(d.next_issue_date)
            //                 .local()
            //                 .format("DD-MM-YYYY")
            //         }
            //         else { return null }
            //     },
            //     Cell: this.renderEditable

            // },
            // {
            //     id: 'previous_issue_date',
            //     Header: 'Previous Issue Date',
            //     maxWidth: 200,
            //     accessor: d => {
            //         if (d.previous_issue_date) {
            //             return Moment(d.previous_issue_date)
            //                 .local()
            //                 .format("DD-MM-YYYY")
            //         }
            //         else { return null }
            //     },
            //     Cell: this.renderEditable

            // }
            ,
            {
                id: 'appendix_header',
                Header: 'Appendix Header',
                
                accessor: 'appendix_header',
                Cell: this.renderEditable

            },
            {
                id: 'non_unit_scope',
                Header: 'Non Unit Scope',
                maxWidth: 150,
                accessor: 'non_unit_scope',
                Cell: this.renderEditable

            },
            {
                id: 'include_globe',
                Header: 'Include Globe',
                maxWidth: 150,
                accessor: 'include_globe',
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'allow_editing',
                Header: 'Allow Editing',
                maxWidth: 150,
                accessor: 'allow_editing',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            },
            {
                id: 'led_occs',
                Header: 'LED Occs',
                maxWidth: 150,
                accessor: 'led_occs',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            }
            ,
            {
                id: 'output_type',
                Header: 'Output Type',
                maxWidth: 150,
                accessor: 'output_type',
                Cell: this.renderEditable
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={false}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="cityscopes">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.cityscopes) : this.renderTable(this.state.cityscopes)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="CityscopeList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
